import { snowplowAdapter } from '@utilitywarehouse/tracking-adapter-snowplow-web';
import { trackingClient } from '@utilitywarehouse/tracking-core';

import { SNOWPLOW_ENDPOINT, TRACKER_NAME } from '~/config';

import { partnerReferralContextInterceptor } from './partnerReferralContext';

const tracking = trackingClient({
  adapters: [
    snowplowAdapter({
      collector: SNOWPLOW_ENDPOINT,
      appId: 'partner_personalised_page',
      trackerName: TRACKER_NAME,
    }),
  ],
  interceptors: [partnerReferralContextInterceptor],
});

export default tracking;
